import { API_URL } from '@/const';
import request from '@/plugins/request';
import { IBoolResult, IErrorResult } from '@/types/dto';
import { IHost, ITheme } from '@/types/models';
import utils from '@/utils';
import { AxiosError, AxiosResponse } from 'axios';

const $url = '/my/templates';
const $urlGetHosts = '/my/templates/actions/getHosts';
const $urlGetTheme = '/my/templates/actions/getTheme';
const $urlUpload = '/my/templates/actions/upload';
const $urlBuy = '/my/templates/actions/buy';
const $urlPay = '/my/templates/actions/pay';
const $urlQuery = '/my/templates/actions/query';

interface IGetRequest {
  type: string;
}

interface IGetResult {
  themes: ITheme[];
  orderResourceIds: string[];
  userName: string;
  isHostExists: boolean;
}

interface IDeleteRequest {
  name: string;
}

interface IGetHostsResult {
  hosts: IHost[];
}

interface IGetThemeRequest {
  userName: string;
  name: string;
}

interface IGetThemeResult {
  themeDownloadUrl: string;
  guid: string;
}

interface IBuyRequest {
  userName: string;
  name: string;
}

interface IBuyResult {
  previewUrl: string;
  price: number;
  discount: number;
}

interface IPayRequest {
  userName: string;
  name: string;
  channel: string;
  amount: number;
}

interface IPayResult {
  orderNo: string;
  qrCodeUrl: string;
}

interface IQueryRequest {
  orderNo: string;
}

interface IQueryResult {
  isPurchased: boolean;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, { params: req })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(req: IDeleteRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: req,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  getHosts(success: (res: IGetHostsResult) => void) {
    utils.loading(true);
    request
      .get($urlGetHosts)
      .then((response: AxiosResponse<IGetHostsResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  getTheme(req: IGetThemeRequest, success: (res: IGetThemeResult) => void) {
    utils.loading(true);
    request
      .post($urlGetTheme, req)
      .then((response: AxiosResponse<IGetThemeResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  buy(req: IBuyRequest, success: (res: IBuyResult) => void) {
    utils.loading(true);
    request
      .post($urlBuy, req)
      .then((response: AxiosResponse<IBuyResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  pay(req: IPayRequest, success: (res: IPayResult) => void, failure: (error: AxiosError<IErrorResult> | string) => void) {
    utils.loading(true);
    request
      .post($urlPay, req)
      .then((response: AxiosResponse<IPayResult>) => {
        success(response.data);
        utils.loading(false);
      })
      .catch(error => {
        failure(error);
      });
  },

  query(req: IQueryRequest, success: (res: IQueryResult) => void) {
    request
      .post($urlQuery, req)
      .then((response: AxiosResponse<IQueryResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },

  getUploadUrl() {
    return API_URL + $urlUpload;
  },
};
